/* eslint-disable no-useless-catch */
const checkInstallation = async (
  shop = 'dev',
  { reauthorize = false } = {}
) => {
  if (!shop || shop === 'dev') {
    return true;
  }

  const url = `${process.env.REACT_APP_SHOPIFIC_GATEWAY_URI}/api/oauth`;
  try {
    const result = await fetch(url, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'PostmanRuntime/7.24.1',
      },
      body: JSON.stringify({
        shop,
        ...(reauthorize ? { reauthorize: true } : {}),
      }),
    });

    const { errors, callbackURL, ...body } = await result.json();

    if (errors) {
      throw new Error('Installation error');
    }

    if (callbackURL) {
      return {
        callbackURL,
      };
    }

    return body;
  } catch (err) {
    throw err;
  }
};

export default checkInstallation;
